import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  EditInteractiveDataAnalysisSignalsComponent
} from '@components/pages/page-components/interactive-data-analysis/modal/edit-interactive-data-analysis-signals/edit-interactive-data-analysis-signals.component';
import {InteractiveDataAnalysisConfig} from '@models/pages/interactive-data-analysis/interactive-data-analysis-config';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {
  InteractiveDataAnalysisService
} from '@services/left-menu/page/interactive-data-analysis/interactive-data-analysis.service';
import {ModalService} from '@services/modal/modal.service';
import {NotificationService} from '@services/notification/notification.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-interactive-data-analysis-actions',
    templateUrl: './interactive-data-analysis-actions.component.html',
    styleUrls: ['./interactive-data-analysis-actions.component.scss'],
    standalone: false
})
export class InteractiveDataAnalysisActionsComponent {

  private readonly COMPONENT_NAME = 'InteractiveDataAnalysisActionsComponent';

  @Input()
  isHigherThanAdmin: boolean = false;

  @Input()
  public machineId: string | null = null;

  @Output()
  chartDataExportTriggered: EventEmitter<string> = new EventEmitter;

  @Input()
  useColorPalette: boolean = false;

  @Output()
  public toggleUseColorPalette: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  interactiveDataAnalysisConfig: EventEmitter<InteractiveDataAnalysisConfig> = new EventEmitter<InteractiveDataAnalysisConfig>();

  constructor(private modalService: ModalService,
              private loadingIndicator: LoadingIndicatorService,
              private dataAnalysisService: InteractiveDataAnalysisService,
              private notificationService: NotificationService,
              private translateService: TranslateService) {
  }

  public onEditSignals(): void {
    const modalRef = this.modalService.open(EditInteractiveDataAnalysisSignalsComponent, {size: 'lg'});
    modalRef.componentInstance.machineId = this.machineId;
    modalRef.componentInstance.useColorPalette = this.useColorPalette;
    modalRef.result.then((interactiveDataAnalysisConfig: InteractiveDataAnalysisConfig) => {
      this.loadingIndicator.show();
      if (this.machineId) {
        this.dataAnalysisService.updateConfiguration(this.machineId, interactiveDataAnalysisConfig).subscribe({
          next: () => {
            this.interactiveDataAnalysisConfig.emit(interactiveDataAnalysisConfig);
            this.loadingIndicator.hide();
            this.notificationService.success(
              this.translateService.instant('Interactive data analysis signals properties updated.'),
              this.COMPONENT_NAME,
              false
            );
          }, 
          error: (error) => {
            this.loadingIndicator.hide();
            this.notificationService.error(
              this.translateService.instant('There was a problem updating Interactive data analysis signal properties.'),
              error,
              this.COMPONENT_NAME,
              false
            );
          }
        });
      }
    }, () => {
      this.loadingIndicator.hide();
    });
  }

  public onToggleUseColorPalette(): void {
    this.toggleUseColorPalette.emit(true);
  }

  onXlsExport() {
    this.chartDataExportTriggered.emit('xls' + new Date().getTime());
  }

  onCsvExport() {
    this.chartDataExportTriggered.emit('csv' + new Date().getTime());
  }
}
